import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import CampaignIcon from '@mui/icons-material/Campaign';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DiscountIcon from '@mui/icons-material/Discount';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { NavLink, useLocation } from 'react-router';
import { useContext } from 'react';
import { DataContext } from '../contexts/DataContext';
import { AuthContext } from '../contexts/AuthContext';

const brandItems = [
  {
    text: 'Home',
    icon: <HomeRoundedIcon />,
    link: '/dashboard',
    allowedRoles: ['employee', 'merchant_admin'],
  },
  {
    text: 'Campaigns',
    icon: <AnalyticsRoundedIcon />,
    link: '/dashboard/campaigns',
    allowedRoles: ['merchant_admin'],
  },
  {
    text: 'Transactions',
    icon: <ReceiptIcon />,
    link: '/dashboard/brand-transactions',
    allowedRoles: ['merchant_admin'],
  },
  {
    text: 'Withdrawal Requests',
    icon: <ReceiptIcon />,
    link: '/dashboard/withdrawal-requests',
    allowedRoles: ['merchant_admin'],
  },
  // {
  //   text: 'Invoices',
  //   icon: <ReceiptIcon />,
  //   link: '/dashboard/merchant-invoices',
  //   allowedRoles: ['merchant_admin'],
  // },
  {
    text: 'Analytics',
    icon: <AnalyticsRoundedIcon />,
    link: '/dashboard/brand-analytics',
    allowedRoles: ['merchant_admin'],
  },
  // { text: 'Clients', icon: <PeopleRoundedIcon /> },
  // { text: 'Tasks', icon: <AssignmentRoundedIcon /> },
];

const trandingAdminItems = [
  {
    text: 'Dashboard',
    icon: <HomeRoundedIcon />,
    link: '/dashboard',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Brands',
    icon: <StorefrontIcon />,
    link: '/dashboard/merchants',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Brands Priority',
    icon: <StorefrontIcon />,
    link: '/dashboard/brands-priority',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Campaigns',
    icon: <CampaignIcon />,
    link: '/dashboard/campaigns',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Campaigns Priority',
    icon: <CampaignIcon />,
    link: '/dashboard/campaigns-priority',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Affiliate Transactions',
    icon: <ReceiptIcon />,
    link: '/dashboard/affiliate-transactions',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Brand Transactions',
    icon: <ReceiptIcon />,
    link: '/dashboard/tranding-merchant-transactions',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Withdrawal Requests',
    icon: <ReceiptIcon />,
    link: '/dashboard/withdrawal-requests',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Brand Withdrawal Requests',
    icon: <ReceiptIcon />,
    link: '/dashboard/brand-withdrawal-requests',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Invoices',
    icon: <ReceiptIcon />,
    link: '/dashboard/tranding-admin-invoices',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Notifications',
    icon: <NotificationsIcon />,
    link: '/dashboard/notifications',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Vouchers',
    icon: <DiscountIcon />,
    link: '/dashboard/vouchers',
    allowedRoles: ['tranding_admin'],
  },
];

const secondaryListItems = [
  {
    text: 'Profile',
    icon: <AccountCircleIcon />,
    link: '/dashboard/profile',
    allowedRoles: ['merchant_admin', 'merchant_employee'],
  },
  {
    text: 'User Management',
    icon: <AccountCircleIcon />,
    link: '/dashboard/user-management',
    allowedRoles: ['tranding_admin'],
  },
  {
    text: 'Account',
    icon: <AccountCircleIcon />,
    link: '/dashboard/account',
    allowedRoles: ['tranding_admin', 'merchant_admin', 'merchant_employee'],
  },
  // { text: 'About', icon: <InfoRoundedIcon /> },
  // { text: 'Feedback', icon: <HelpRoundedIcon /> },
];

export default function MenuContent() {
  const location = useLocation();
  const authCtx = useContext(AuthContext);
  const dataCtx = useContext(DataContext);

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      {authCtx.userRole === 'tranding_admin' && (
        <List dense>
          {trandingAdminItems
            .filter((el) => el.allowedRoles.includes(authCtx.userRole!))
            .map((item) => (
              <NavLink
                onClick={(_) => {
                  dataCtx.setDrawerOpen(false);
                }}
                to={item.link ?? '#'}
                key={item.text}
                style={{ textDecoration: 'none', color: 'inherit' }}>
                <ListItem
                  key={item.text}
                  disablePadding
                  sx={{ display: 'block' }}>
                  <ListItemButton selected={item.link === location.pathname}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            ))}
        </List>
      )}
      <List dense>
        {brandItems
          .filter((el) => el.allowedRoles?.includes(authCtx.userRole!))
          .map((item) => (
            <NavLink
              onClick={(_) => {
                dataCtx.setDrawerOpen(false);
              }}
              to={item.link ?? '#'}
              key={item.text}
              style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItem
                key={item.text}
                disablePadding
                sx={{ display: 'block' }}>
                <ListItemButton selected={item.link === location.pathname}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            </NavLink>
          ))}
      </List>
      <List dense>
        {secondaryListItems
          .filter((el) => el.allowedRoles.includes(authCtx.userRole!))
          .map((item) => (
            <NavLink
              onClick={(_) => {
                dataCtx.setDrawerOpen(false);
              }}
              to={item.link ?? '#'}
              key={item.text}
              style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItem
                key={item.text}
                disablePadding
                sx={{ display: 'block' }}>
                <ListItemButton selected={item.link === location.pathname}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            </NavLink>
          ))}
      </List>
    </Stack>
  );
}
